import React from 'react';
import { Email, Box, Item, Span, A, Image, renderEmail } from '../../library/react-html-email';

const css = `
  * { border: none, outline: 0 }
    body,html { background-color: #d9d9d9 }
    body,html,table,table td { font-size: 15px; font-family: Arial, sans-serif !important}
    body { -webkit-text-size-adjust: none; -ms-text-size-adjust: none; margin: 0; line-height: 1.2 }
    table { mso-table-lspace: 0; mso-table-rspace: 0; table-layout: fixed }
    table table { table-layout: auto }
    table,table td { border-collapse: collapse }
    img { border: 0; display: block }
`.trim();

const Template = function(values) {
  return (
    <Email title="Offers" headCSS={css} width="100%" bgcolor="#d9d9d9">
      <Item align="center">
        <Box width="580" bgcolor="#ffffff" align="center">
          <Item id="Branding" align="center">
            <Box width="520" bgcolor="#ffffff" align="center">
              <Item align="right">
                <A href="http://www.mobil.co.uk/">
                  <Image
                    src={values.copy.asset_path + 'images/email/mobil-logo.jpg'}
                    width={106}
                    height={41}
                    alt="Mobil"
                  />
                </A>
              </Item>
            </Box>
          </Item>
          <Item id="Title" align="center">
            <Box width="520" bgcolor="#ffffff" align="center" style={{ paddingBottom: '20px' }}>
              <Item align="left">
                <Span fontSize={32} color="#5a5a5a" style={{ lineHeight: '1.1' }}>
                  {values.copy.title}
                </Span>
              </Item>
            </Box>
          </Item>
          <Item id="Image" align="center">
            <Box width="580" bgcolor="#ffffff" align="center">
              <Item align="center">
                <A href="http://www.mobil.co.uk/">
                  <Image
                    src={values.copy.asset_path + 'images/email/header.jpg'}
                    width={580}
                    height={299}
                    alt="Header"
                  />
                </A>
              </Item>
            </Box>
          </Item>
          <Item id="Body" align="center">
            <Box width="520" bgcolor="#ffffff" align="center">
              <Item align="left" style={{ padding: '20px 0' }}>
                <Span>{values.copy.salutation},</Span>
                <br />
                <br />
                {values.copy.message.split('\n\n').map((line, i) => (
                  <Span key={i}>
                    {line}
                    <br />
                    <br />
                  </Span>
                ))}
              </Item>
            </Box>
          </Item>
          <Item id="FooterBlue" align="center">
            <Box width="580" bgcolor="#309cd6" align="center">
              <Item align="center">
                <Image
                  src={values.copy.asset_path + 'images/email/footer-viz-min.jpg'}
                  width={580}
                  height={49}
                  alt="Energy Lives"
                />
              </Item>
            </Box>
          </Item>
          <Item id="Footer" align="center" bgcolor="#2b2b2b">
            <Box
              width="200"
              bgcolor="#2b2b2b"
              align="left"
              className="stack-me"
              style={{ padding: '10px 0px 0px 30px' }}
            >
              <Item bgcolor="#2b2b2b">
                <A
                  href="http://corporate.exxonmobil.com/"
                  color="#a6a6a6"
                  textDecoration="none"
                  fontSize={10}
                >
                  <Image
                    src={values.copy.asset_path + 'images/email/EM_logo2.jpg'}
                    width={86}
                    height={25}
                    alt="ExxonMobil"
                  />
                </A>
              </Item>
              <Item bgcolor="#2b2b2b" style={{ paddingBottom: '20px' }}>
                <Box width="34">
                  <A
                    href="http://www.exxon.com/"
                    color="#a6a6a6"
                    textDecoration="none"
                    fontSize={10}
                  >
                    <Image
                      src={values.copy.asset_path + 'images/email/EM_logo1.jpg'}
                      width={34}
                      height={20}
                      alt="Exxon"
                    />
                  </A>
                </Box>
                <Box width="40">
                  <A
                    href="http://www.mobil.com/"
                    color="#a6a6a6"
                    textDecoration="none"
                    fontSize={10}
                  >
                    <Image
                      src={values.copy.asset_path + 'images/email/Mobil_logo.jpg'}
                      width={40}
                      height={20}
                      alt="Mobil"
                    />
                  </A>
                </Box>
                <Box width="40">
                  <A
                    href="http://www.mobil.com/"
                    color="#a6a6a6"
                    textDecoration="none"
                    fontSize={10}
                  >
                    <Image
                      src={values.copy.asset_path + 'images/email/esso_logo.jpg'}
                      width={37}
                      height={20}
                      alt="Esso"
                    />
                  </A>
                </Box>
                <Box width="40">
                  <A
                    href="http://www.xtoenergy.com/"
                    color="#a6a6a6"
                    textDecoration="none"
                    fontSize={10}
                  >
                    <Image
                      src={values.copy.asset_path + 'images/email/Xto_logo.jpg'}
                      width={38}
                      height={20}
                      alt="XTO"
                    />
                  </A>
                </Box>
              </Item>
            </Box>
            <Box
              width="280"
              bgcolor="#2b2b2b"
              align="right"
              style={{ padding: '10px 30px 10px 0px', textAlign: 'right' }}
            >
              <Item
                align="right"
                style={{ lineHeight: '15px !important', fontSize: '10px', paddingBottom: '10px' }}
              >
                <A
                  href="http://corporate.exxonmobil.com/en/global-legal-pages/privacy-policy"
                  color="#a6a6a6"
                  fontSize="10px"
                >
                  {values.copy.privacy}
                </A>{' '}
                &nbsp;
                <A
                  href="http://corporate.exxonmobil.com/en/global-legal-pages/terms-and-conditions"
                  color="#a6a6a6"
                  fontSize="10px"
                >
                  {values.copy.terms}
                </A>
              </Item>
              <Item align="right" style={{ lineHeight: '15px !important', fontSize: '10px' }}>
                <Span color="#a6a6a6" fontSize={10}>
                  {values.copy.copyright}
                  <br />
                  {values.copy.rights}
                </Span>
              </Item>
            </Box>
          </Item>
        </Box>
      </Item>
    </Email>
  );
};

export const GetEmailTemplate = function(props) {
  return renderEmail(<Template {...props} />);
};



// WEBPACK FOOTER //
// ./src/components/EmailForm/Template.js